import { BASE_URL } from "../configs";
import { getAccessToken } from "../helpers/auth/token";
import axiosInstance from "./axios"

export async function uploadFile(file, fields) {
  let url = `${BASE_URL}/api/file`;

  const formData = new FormData();
  formData.append("file", file);

  if (fields) {
    Object.keys(fields).forEach((key) => {
      if (
        fields[key] !== null &&
        fields[key] !== undefined &&
        fields[key] !== ""
      )
        formData.append(key, fields[key]);
    });
  }

  const res = await axiosInstance.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })

  return res.data.Data
}

export function getFileUrl(file) {
  let url = `${BASE_URL}/api/file/${file.id}?token=${getAccessToken()}`;
  return url;
}
